
import { getGlobalCache, setGlobalCache } from '../supabaseCache';
import { getCache, setCacheEntry, TTL_GEO } from '../cache/secureStorage';

const SV_CACHE_KEY = 'sal_sv_cache_v1';

/**
 * v3.0: Centralized Street View Metadata with hybrid caching (Local + Supabase)
 */
export const getStreetViewMetadata = async (
    lat: number, lng: number,
    apiKey?: string
): Promise<string | null> => {

    // Key precisa de apenas 4 casas de precisão (mesmo ponto da rua)
    const key = `sv_${lat.toFixed(4)}_${lng.toFixed(4)}`;
    const safeKey = btoa(key);

    // 1. CACHE LOCAL (Memória/LocalStorage)
    const local = getCache(SV_CACHE_KEY, TTL_GEO);
    if (local[key]) return local[key].data;

    // 2. CACHE GLOBAL (Supabase)
    try {
        const cached = await getGlobalCache<{ panoId?: string }>(`sv_${safeKey}`);
        if (cached?.panoId) {
            setCacheEntry(SV_CACHE_KEY, key, cached.panoId, TTL_GEO);
            return cached.panoId;
        }
    } catch (e) { }

    // 3. GOOGLE API
    if (!apiKey) return null;

    try {
        const url = `https://maps.googleapis.com/maps/api/streetview/metadata?location=${lat},${lng}&key=${apiKey}`;
        const res = await (await fetch(url)).json();

        if (res.status === 'OK' && res.pano_id) {
            const panoId = res.pano_id;

            // Salva Local
            setCacheEntry(SV_CACHE_KEY, key, panoId, TTL_GEO);

            // Salva Global
            try {
                await setGlobalCache(`sv_${safeKey}`, 'street_view', {
                    panoId,
                    lat, lng,
                    updatedAt: Date.now()
                });
            } catch (e) { }

            return panoId;
        }
    } catch (e) {
        console.error("[StreetViewAPI] Fetch Error:", e);
    }

    return null;
};

export const getStreetViewImageUrl = (lat: number, lng: number, apiKey: string, heading: number = 0, panoId?: string) => {
    if (!apiKey) return '';
    if (panoId) return `https://maps.googleapis.com/maps/api/streetview?size=600x400&pano=${panoId}&heading=${heading}&pitch=0&key=${apiKey}`;
    return `https://maps.googleapis.com/maps/api/streetview?size=600x400&location=${lat},${lng}&heading=${heading}&pitch=0&key=${apiKey}`;
};
